'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Abacus(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-abacus', className),
      width: width,
      height: height,
      viewBox: '0 0 48 48' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: '', d: 'M0 0h48v48H0z' }),
      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M4.867 12.583v-2H44.2v2zM4.867 20.05v-2H44.2v2zM4.867 27.517v-2H44.2v2z' }),
      _react2.default.createElement('circle', { cx: '36', cy: '26.333', r: '2.933', fill: color, fillRule: 'nonzero' }),
      _react2.default.createElement('circle', { cx: '36', cy: '19.133', r: '2.933', fill: color, fillRule: 'nonzero' }),
      _react2.default.createElement('circle', { cx: '11.467', cy: '11.6', r: '2.933', fill: color, fillRule: 'nonzero' }),
      _react2.default.createElement('circle', { cx: '18.933', cy: '11.6', r: '2.933', fill: color, fillRule: 'nonzero' }),
      _react2.default.createElement('circle', { cx: '27.6', cy: '26.333', r: '2.933', fill: color, fillRule: 'nonzero' }),
      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M2 4.256h3v38.011H2zM43 4.256h3v38.011h-3z' }),
      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M4 33h40v3H4zM0 42h7v3H0zM41 42h7v3h-7z' })
    )
  );
}

Abacus.propTypes = {
  color: _react.PropTypes.string,
  className: _react.PropTypes.string,
  width: _react.PropTypes.number,
  height: _react.PropTypes.number
};

Abacus.displayName = 'Abacus';

exports.default = Abacus;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Abacus/Abacus.js
// module id = 1083
// module chunks = 1